import Vue from 'vue';
import {
  LayoutPlugin, CardPlugin,
  LinkPlugin, InputGroupPlugin,
  FormInputPlugin, NavbarPlugin, ButtonPlugin,
  FormGroupPlugin, PaginationPlugin,
  FormTextareaPlugin, FormPlugin, ModalPlugin, FormCheckboxPlugin, ToastPlugin, ImagePlugin,
} from 'bootstrap-vue';

Vue.use(LayoutPlugin);
Vue.use(CardPlugin);
Vue.use(LinkPlugin);
Vue.use(InputGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(NavbarPlugin);
Vue.use(ButtonPlugin);
Vue.use(PaginationPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormPlugin);
Vue.use(ModalPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(ToastPlugin);
Vue.use(ImagePlugin);
